import { render, staticRenderFns } from "./organization-admins-form.vue?vue&type=template&id=5afc61fc&"
import script from "./organization-admins-form.vue?vue&type=script&lang=js&"
export * from "./organization-admins-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports